import { CUSTOMS, LABEL, OVERVIEW, PACKAGE, RECEIVER, SHIPPER, PAYMENT } from '~/basket/model/constants'

export const shipmentLinks = {
  shipmentLink: () => '',
  shipmentPackageLink: () => `/${PACKAGE}`,
  shipmentReceiverLink: () => `/${RECEIVER}`,
  shipmentShipperLink: () => `/${SHIPPER}`,
  shipmentCustomsLink: () => `/${CUSTOMS}`,
  shipmentOverviewLink: () => `/${OVERVIEW}`,
  shipmentParcelshopPaymentLink: () => `/${PAYMENT}`,
  shipmentLabelOverviewLink: () => `/${LABEL}`,
  shipmentLabelLink: ({ orderId }: { orderId: string }) => `/${LABEL}?orderId=${orderId}`,
}
